module.exports = __webpack_public_path__ + "static/media/IMG_0091-2.7317eddc.jpg";